import React, { SVGProps } from 'react';

const Dollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0.583374V13.4167M9.91667 2.91671H5.54167C5.00018 2.91671 4.48088 3.13181 4.09799 3.5147C3.7151 3.89758 3.5 4.41689 3.5 4.95837C3.5 5.49986 3.7151 6.01916 4.09799 6.40205C4.48088 6.78494 5.00018 7.00004 5.54167 7.00004H8.45833C8.99982 7.00004 9.51912 7.21514 9.90201 7.59803C10.2849 7.98092 10.5 8.50022 10.5 9.04171C10.5 9.58319 10.2849 10.1025 9.90201 10.4854C9.51912 10.8683 8.99982 11.0834 8.45833 11.0834H3.5"
      stroke="#6C7DC0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Dollar;
